import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledListItemContainer = styled.div`
    border: 1px solid ${colorsPalettes.carbon[50]};
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
    height: 64px;
    padding-left: 20px;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    background: ${colorsPalettes.carbon[0]};

    &:hover {
        border-radius: 8px;
        border: 1px solid #eceef0;
        background: ${colorsPalettes.carbon[0]};
        box-shadow: 0px 18px 34px 0px rgba(14, 30, 62, 0.12);
    }
`;

export const StyledListItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-grow: 1;
    min-width: 0;
    overflow: hidden;

    &:hover {
        cursor: pointer;
    }
`;

export const StyledListItemMainBlock = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

export const StyledListItemMainData = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    align-items: flex-start;
`;

export const StyledListName = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 600px;
    @media (max-width: 1280px) {
        max-width: 570px;
    }
    @media (max-width: 1180px) {
        max-width: 500px;
    }
    @media (max-width: 1100px) {
        max-width: 350px;
    }
    @media (max-width: 950px) {
        max-width: 200px;
    }
`;

export const StyledListLastUpdatedDate = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
`;

export const StyledMetadataBlock = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    flex-shrink: 0;
`;

export const StyledListMetadata = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid ${colorsPalettes.carbon[50]};
    padding: 0 20px;

    &.noBorder {
        border: none;
    }
`;

export const StyledListValue = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])}
`;

export const StyledListCaption = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
    width: 99px;
    text-align: center;
`;
